<template>
    <div>
        <v-menu location="bottom" :close-on-content-click="false" :z-index="2500">
            <template v-slot:activator="{ props }">
                <div class="pa-1  add-measure-container" v-bind="props">
                    <span ><v-icon>mdi-plus</v-icon> {{addButtonText}}</span>
                </div>
            </template>
            <div id="multiple-select-dropdown">

                <v-list style="max-height: 500px; overflow-y: scroll" density="compact">
                    <v-list-item
                        v-for="(item, index) in formattedItems"
                        :key="index"
                    >
                        <template v-slot:prepend>
                            <v-checkbox-btn v-model="item.isSelected" @update:model-value="e => addRemoveItem(e, item, index)"></v-checkbox-btn>
                        </template>

                        <div style="display: flex; align-items: center">
                            <img :src="item.image" alt="item-image" v-if="item.image" style="height: 25px; margin-right: 8px">
                            <v-list-item-title>{{ item[itemTitle] }}</v-list-item-title>
                        </div>
                        <v-list-item-subtitle>{{ item[itemSubtitle] }}</v-list-item-subtitle>
                    </v-list-item>
                </v-list>

            </div>

        </v-menu>
        <draggable
            :list="selectedItems"
            :disabled="!draggable"
            class="list-group"
            ghost-class="ghost"
            :move="checkMove"
            @start="dragging = true"
            @end="dragging = false"
            item-key="id"
        >
            <template #item="{element: item, index}">
            <div
                :class="{'pa-2 mt-2 measure-container list-group-item': true, 'draggable': draggable}"
                :style="{borderLeftColor: item.color ? item.color : 'inherit'}"
                style="display: flex"
                :key="index">
                <div style="flex: 1">
                    <v-icon v-if="draggable">mdi-drag-vertical</v-icon>
                    <span >{{item[itemTitle]}}</span>
                </div>
                <div @click="removeItem(index)" class="pointer">
                    <v-icon>mdi-close</v-icon>
                </div>


            </div>
            </template>
        </draggable>



       
    </div>
</template>

<script>

import draggable from 'vuedraggable'

// Pretty sure there's a lot of room for improvement in this code but just knocked it out fast

export default {
    name: "AppMultipleSelect",
    emits: ['input', 'update:modelValue'],
    components: {
        draggable,
    },

    props: {
        draggable: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            required: true
        },
        value: {
            type: Array,
            default: () => []
        },
        modelValue: {
            type: Array,
            default: () => []
        },
        itemValue: {
            required: true,
            type: String
        },
        itemTitle: {
            required: true,
            type: String
        },
        itemSubtitle: {
            required: false,
            type: String
        },
        addButtonText: {
            type: String,
            default: "Add New"
        }

    },
    data() {
        return {
            selectedItems: []
        }
    },
    mounted() {
        this.initSelectedItems()

    },
    watch: {
        items: function(newValue, oldValue) {
            this.initSelectedItems()
        },
        inputValue: function(newValue, oldValue) {
            const currentIds = this.selectedItems.map(x => x[this.itemValue]);
            const isSame = newValue.length === currentIds.length &&
                newValue.every(id => currentIds.includes(id));
            if (!isSame) {
                this.initSelectedItems()
            }
        },
        selectedItems: {
            handler(newValue, oldValue) {
                let value = [];
                newValue.forEach(x => {
                   value.push(x[this.itemValue])
                })
                this.$emit('input', value)
                this.$emit('update:modelValue', value)
            },
            deep: true
        }
    },
    computed: {
        inputValue() {
            const mv = this.modelValue;
            const v = this.value;
            if (mv && mv.length > 0) return mv;
            return v || [];
        },
        formattedItems() {
            return this.items.map(item => {
                item.isSelected = !!this.inputValue.find(x => x === item[this.itemValue])
                return item
            })
        }
    },
    methods: {
        initSelectedItems() {
            const self = this;
            let temp = this.items;
            if (!(this.items.length > 0)) return []
            let selectedItems = [];


            this.inputValue.forEach(item => {
                // const something = self.items;
                // let somethingelse = item;
                // 

                let fullItem = self.items.find(x => x[self.itemValue] === item)
                if (fullItem) {
                    selectedItems.push(fullItem)
                }
            });
            //
            // 

            this.selectedItems = selectedItems;
        },
        checkMove: function(e) {
            window.console.log("Future index: " + e.draggedContext.futureIndex);
        },
        addRemoveItem(e, item, index) {
            if (e) {
                this.selectedItems.push(item)
            } else {
                let itemIndex = this.selectedItems.findIndex(x => x[this.itemValue] === item[this.itemValue]);
                this.selectedItems.splice(itemIndex, 1);
                
            }

        },
        removeItem(index) {
            this.selectedItems.splice(index, 1)
        },
        isSelected(item) {
            let temp = this.selectedItems.find(x => x[this.itemValue] === item[this.itemValue]);
            let longword = !!temp
            return longword
        }
    }
}
</script>

<style scoped>
.measure-container {
    width: 100%;
    height: 43px;
    border-radius: 10px;
    border: 2px solid #e0e0e0;
    background-color: #f5f5f5;
    display: flex;
    align-items: center
}

.draggable:hover {
    cursor: move
}


.add-measure-container {
    width: 100%;
    height: 43px;
    border-radius: 10px;
    border: 2px solid #e0e0e0;
    background-color: #f5f5f5;
    display: flex;
    align-items: center
}

.add-measure-container:hover {
    cursor: pointer;
    background-color: #eeeeee;
}

/*.list-group:hover {*/
/*    cursor: move;*/
/*}*/

.list-group-item {
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    border-left: 5px solid rgb(var(--v-theme-secondary));
    background-color: white;
}


</style>